import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomvariableComponent } from '../customvariable/customvariable.component';
declare var CKEDITOR: any;
@Component({
  selector: 'app-texteditor',
  templateUrl: './texteditor.component.html',
  styleUrls: ['./texteditor.component.css']
})
export class TexteditorComponent implements OnInit {
  @Output() public editorscript = new EventEmitter<any>();
  @Input() public editscripteditor:string;

    leadValue: any;
    constructor(private modalService: NgbModal) { }

    ngOnInit() { 
      console.log(this.editscripteditor);
    }

    validateChange(event:any)
    {
      console.log(event);
      if(event!==null && event!==undefined)
      {
        console.log(event);
        this.editorscript.emit(event);
      }
       
    }
  


    insert_name(event)
    {
        event.insertText("#{user_name}");
        console.log("Testing");
    }
    customVar()
    {
      console.log("event");
      const modalRef = this.modalService.open(CustomvariableComponent, {
        size: 'lg',
        centered: true,
        scrollable: true
      })
      modalRef.componentInstance.data = {
      }
      modalRef.result.then((result) => {
        console.log(result);
        // if(result!=null && result!=undefined){
          var sel, curspos;
          sel = window.getSelection();
          curspos= sel.getRangeAt(0);
          console.log(curspos);
          this.leadValue= curspos.insertNode(document.createTextNode('{'+result.leadType.toUpperCase()+'}'));
           console.log('The dialog was closed',this.leadValue);
          // }
      })
    }

}
